import theme from "@/theme";

export interface MetricItem {
  id: string;
  title: string;
  value: string;
  status: string;
  showChevron?: boolean;
}

export enum WellnessScoreStatus {
  Healthy,
  NeedsAttention,
  NeedsSupport,
  Incomplete,
}

export interface WellnessCategoryCardProps {
  icon: React.ReactNode;
  title: string;
  status?: WellnessScoreStatus;
  description: string;
  lastUpdated?: string;
  children?: React.ReactNode;
}

export const status: Record<string, string> = {
  healthy: "healthy",
  needAttention: "needAttention",
  needsSupport: "needsSupport",
};

export const healthStatusColours: Record<string, string> = {
  healthy: theme.palette.accent1.main,
  needsAttention: theme.palette.secondary[700] as string,
  needsSupport: theme.palette.error.main,
};
